import { type FilterWizardEventData } from '@biome-design-system/toolkit/FilterWizard';
import { type SearchModification } from 'Src/types';

/**
 * Gets the query modifications based on the answer data.
 *
 * @param answer The answer data from the FilterWizard event.
 * @returns An array of search modifications.
 */
export const getAnswerQueryModifications = (
  answer: Partial<FilterWizardEventData['answer']>
): SearchModification[] => {
  const { filter_key, filter } = answer || {};
  if (!filter_key || !filter) {
    return [];
  }

  return [
    { action: 'delete_key', key: 'unified' },
    { action: 'append', key: filter_key, value: filter }
  ];
};
